import { render, staticRenderFns } from "./signatureVerification.vue?vue&type=template&id=56b11927"
import script from "./signatureVerification.vue?vue&type=script&lang=js"
export * from "./signatureVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports